enum ErrorResultCode {
    DEFAULT_ERROR_CODE = -100,
    PARAMETER_ERROR_CODE = -200,
    LOGIN_ERROR_CODE = -300
}

export default ErrorResultCode;
